jQuery( function( $ ) {
	$( document ).ready( function() {

		airportsJS = ( function() {

			var
				init = function() {
				}
			;

			return {
				init: init
			};

		}() );

		airportsMapJS = ( function() {

			var
				_pins = [],

				_map = false,

				_bounds = false,

				_modal = $( '#location-modal-map' ),

				_trigger = $( '#location-modal-trigger' ),

				init = function( data ) {

					if ( data ) {
						_pins = JSON.parse( data );
					}

					_trigger.click( function() {

						if ( ! _map ) {
							_map = new google.maps.Map( document.getElementById( 'location-map' ), {
								zoom: 12
							});

							_bounds = new google.maps.LatLngBounds();

							$.each( _pins, function( i, pin ) {
								var marker = new google.maps.Marker( {
									position: pin,
									map: _map
								} );

								_bounds.extend( marker.position );
							} );

							// _map.fitBounds( _bounds );
							_map.setCenter( _bounds.getCenter() );
							_map.setZoom( 10 );
						}

						if ( _map ) {
							_modal.modal( 'show' );
						}

					} );
				}
			;

			return {
				init: init
			};

		}() );

	});

	$( document ).on( 'initAirportMap', function( e, data ) {
		airportsMapJS.init( data );
	} );
});
